export const suppliers = [
    { id: 1, name: "Supplier A", contact: "supplierA@example.com" },
    { id: 2, name: "Supplier B", contact: "supplierB@example.com" },
    { id: 3, name: "Supplier C", contact: "supplierC@example.com" },
];
